import { useEffect } from 'react';

import { BookOutlined } from '@ant-design/icons';
import { t } from '../../languages';
import { recordPageGA } from '../../modules/ga';

const ClassesList = ({ lang, classes, onClassClick }) => {

  // Registro en Google Analytics
  useEffect(() => {
    recordPageGA('/classes-list');
  }, []);

  const handleClassClick = (aClass) => {
    onClassClick(aClass);
  }

  if (classes && classes.length > 0) {
    return (
      <section className="classes-list">
        <ul className="class-items">
          {classes.map((aClass) => (
            <li key={aClass.id} className="class-item" onClick={() => { handleClassClick(aClass) }}>
              <BookOutlined className="class-icon" />
              <div className="class-info">
                <strong>{aClass.name}</strong>
                <div className="class-code">{aClass.code}</div>
              </div>
            </li>
          ))}
        </ul>
      </section >)
  } else return null;
};

export default ClassesList;